import { produce } from "immer";

import type { FeatureReminderType } from "../types/featureReminder";

import { zustandStore } from "./zustand.helpers";

export interface FeatureReminderState {
    featureReminderType?: FeatureReminderType;
    dismissed: boolean;
}

export const initialState: FeatureReminderState = {
    featureReminderType: undefined,
    dismissed: false,
};

export interface FeatureReminderActions {
    setFeatureReminderType: (featureReminderType?: FeatureReminderType) => void;
    setDismissed: (dismissed: boolean) => void;
    reset: () => void;
    resetAndDismiss: () => void;
}

export const { store: featureReminderStore } = zustandStore<
    FeatureReminderState,
    FeatureReminderActions
>("FeatureReminder", initialState, (set: any, get: any) => ({
    setDismissed: (dismissed: boolean) =>
        set(() => {
            const state: FeatureReminderState = get();
            return produce(state, (draft) => {
                draft.dismissed = dismissed;
                return draft;
            });
        }),
    setFeatureReminderType: (featureReminderType?: FeatureReminderType) =>
        set(() => {
            const state: FeatureReminderState = get();
            return produce(state, (draft) => {
                draft.featureReminderType = featureReminderType;
                return draft;
            });
        }),
    reset: () => set(() => ({ ...initialState })),
    resetAndDismiss: () => set(() => ({ ...initialState, dismissed: true })),
}));
